import './Header.css';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import imageLogo from './../../../images/magmic_core_logo_main_menu.png';
import imageMagmicCoin from './../../../images/magmic_coin.png';

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import { getMagmicCoinBalanceString } from '../../assetHelpers';
import { useSelector } from 'react-redux';

import { Auth } from 'aws-amplify';
import { useRef } from 'react';
import reactRouterDom from 'react-router-dom';

function getWindowDimensions() {
  const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
  return {
    windowWidth,
    windowHeight
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const Header = () => {

  const { windowWidth, windowHeight } = useWindowDimensions();

  const mainHeaderBackgroundBottomHeight = 50;
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect( // watch for scroll position changes
    () => {
      const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
      return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  let [mobileMenuModeExpanded, setMobileMenuModeExpanded] = useState(false);
  const mainNavWrapperRef = useRef(null);

  useEffect(() => {
    const checkToCloseMobileNav = (event) => {
      if (!mainNavWrapperRef.current) {
        return;
      }
      if (!mobileMenuModeExpanded) {
        return;
      }
      if (mainNavWrapperRef.current.contains(event.target)) {
        return;
      }
      setMobileMenuModeExpanded(false);
    }
    document.addEventListener("click", checkToCloseMobileNav);
    return () => {
      document.removeEventListener("click", checkToCloseMobileNav);
    }
  }, [mobileMenuModeExpanded]); // https://stackoverflow.com/a/67244193/999934


  let [subNavActiveMap, setSubNavActiveMap] = useState({
    "packs": false,
    "marketplace": false,
    "wallet": false
  });

  const history = useHistory();

  const goTo = (url) => {
    setMobileMenuModeExpanded(false);
    history.push(url);
  }

  const resetSubNavActiveMap = () => {
    setSubNavActiveMap({
      "packs": false,
      "marketplace": false,
      "wallet": false
    });
  }

  const mainNavItemHover = (itemId) => {
    switch (itemId) {
      case "packs":
        setSubNavActiveMap({
          "packs": true,
          "marketplace": false,
          "wallet": false
        });
        break;
      case "marketplace":
        setSubNavActiveMap({
          "packs": false,
          "marketplace": true,
          "wallet": false      
        });
        break;
      case "wallet":
        setSubNavActiveMap({
          "packs": false,
          "marketplace": false,
          "wallet": true      
        });
        break;
      default:
        setSubNavActiveMap({
          "packs": false,
          "marketplace": false,
          "wallet": false
        });
        break;
    }
  }

  const signOut = async () => {
    try {
      await Auth.signOut();
      goTo("/");
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  let userName = userReduxStore.user && userReduxStore.user.attributes && userReduxStore.user.attributes.email ? userReduxStore.user.attributes.email : undefined;
  if (userName && userName.includes("@")) {
    const userNameComponents = userName.split("@");
    userName = userNameComponents[0];
  }

  let mainHeaderContentWrapperClassName = "mainHeaderContentWrapper";
  let mobileMenuMode = false;
  if (windowWidth < 795) {
    mobileMenuMode = true;
    if (mobileMenuModeExpanded) {
      mainHeaderContentWrapperClassName += " expanded";
    }
  }

  let mainHeaderClassName = "mainHeader";
  if (scrollPosition > mainHeaderBackgroundBottomHeight) {
    mainHeaderClassName += " shrinkForScroll";
  } else if (mobileMenuMode) {
    mainHeaderClassName += " shrinkForScroll";
  }

  return (
    <header className={mainHeaderClassName}>
      <div className={mainHeaderContentWrapperClassName}>
        <div className="mainLogo">
          <Link to="/"><img src={imageLogo} alt="Magmic Core" /></Link>
        </div>
        <nav className="mainNav" onMouseLeave={resetSubNavActiveMap}>
          <button className="menuIcon" onClick={() => {setMobileMenuModeExpanded(true)}}>
            <MenuIcon />
          </button>
          <div className="mainNavWrapper" ref={mainNavWrapperRef}>
            <button className="mobileMenuModeCloseButton" onClick={() => {setMobileMenuModeExpanded(false)}}>
              <CloseIcon />
            </button>
            <ul>
              <li onMouseEnter={(e) => {mainNavItemHover("packs")}}>
                <button onClick={(e) => {goTo("/nfts")}}> {/* https://magmic.atlassian.net/browse/MC-100 */}
                  NFTs
                </button>
              </li>
              <li onMouseEnter={(e) => {mainNavItemHover("marketplace")}}>
                <button onClick={(e) => {goTo("/marketplace")}}>
                  Marketplace
                </button>
              </li>
              <li onMouseEnter={(e) => {mainNavItemHover("wallet")}}>
                <button className="userName" onClick={(e) => {goTo("/wallet")}}>
                  {userName ? 
                    <>
                      <div className="username">{userName}</div>
                      {userReduxStore.magmicCoin !== undefined ?
                        <div className="balance">{getMagmicCoinBalanceString(userReduxStore.magmicCoin)} <img src={imageMagmicCoin} /></div>
                      :
                        null
                      }
                    </>
                  :
                    "Sign In"
                  }
                </button>
                {userReduxStore && userReduxStore.user.username ? 
                  <nav className={subNavActiveMap.wallet ? "subNav active" : "subNav"}>
                    <ul>
                      <li>
                        <button onClick={signOut} >Sign Out</button>
                      </li>
                    </ul>
                  </nav>
                :
                  null
                }
              </li>
              <li onMouseEnter={(e) => {mainNavItemHover("help")}}>
                <a href="https://support.magmic.com" target="_blank">
                  Help
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header;